module.exports = __webpack_public_path__ + "img/1326449030.383db093.jpg";